import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import {
  MOMENT_AM_PM_TIME_FORMAT,
  MOMENT_LONG_ABBREVIATED_DATE_FORMAT,
} from 'i2g-ng-utils';
import { IRelativeDateTranslationKey } from '../../pipes/friendly-date/friendly-date.pipe';

@Component({
  selector: 'i2g-chat-list-item',
  templateUrl: 'chat-list-item.component.html',
  styleUrls: ['chat-list-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChatListItemComponent implements OnInit {
  @Input() name: string;
  @Input() date: string;
  @Input() message: string;

  dateFormat = MOMENT_LONG_ABBREVIATED_DATE_FORMAT;
  timeFormat = MOMENT_AM_PM_TIME_FORMAT;
  dateTranslationKeys: IRelativeDateTranslationKey = {
    today: 'JOB.CONVERSATION.DATE.TODAY',
    yesterday: 'JOB.CONVERSATION.DATE.YESTERDAY',
    inOneDay: 'JOB.CONVERSATION.DATE.IN_ONE_DAY',
    nDaysAgo: 'JOB.CONVERSATION.DATE.N_DAYS_AGO',
    inNDays: 'JOB.CONVERSATION.DATE.IN_N_DAYS',
  };

  constructor() {}

  ngOnInit() {}
}
